/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Locked_DescInputs */

const en_vault_locked_desc = /** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase this listing to unlock exclusive digital assets, high-res media, and private instructions.`)
};

const id_vault_locked_desc = /** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli listing ini untuk membuka akses aset digital eksklusif, media resolusi tinggi, dan instruksi pribadi.`)
};

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const es_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const fr_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const de_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const ja_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const zh_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const ar_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const it_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const ru_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const pt_vault_locked_desc = en_vault_locked_desc;

/** @type {(inputs: Vault_Locked_DescInputs) => LocalizedString} */
const ko_vault_locked_desc = en_vault_locked_desc;

/**
* | output |
* | --- |
* | "Purchase this listing to unlock exclusive digital assets, high-res media, and private instructions." |
*
* @param {Vault_Locked_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_locked_desc = /** @type {((inputs?: Vault_Locked_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Locked_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_locked_desc(inputs)
	if (locale === "es") return es_vault_locked_desc(inputs)
	if (locale === "fr") return fr_vault_locked_desc(inputs)
	if (locale === "de") return de_vault_locked_desc(inputs)
	if (locale === "ja") return ja_vault_locked_desc(inputs)
	if (locale === "zh") return zh_vault_locked_desc(inputs)
	if (locale === "ar") return ar_vault_locked_desc(inputs)
	if (locale === "id") return id_vault_locked_desc(inputs)
	if (locale === "it") return it_vault_locked_desc(inputs)
	if (locale === "ru") return ru_vault_locked_desc(inputs)
	if (locale === "pt") return pt_vault_locked_desc(inputs)
	return ko_vault_locked_desc(inputs)
});